export enum ProductOverviewEnums {
  BEVERAGE_PRODUCT = 'Beverage Product',
  CANCEL = 'Cancel',
  SAVE_AS_DRAFT = 'Save as draft',
  TOTAL = 'Total',
  SUBMIT_FOR_APPROVAL = 'Submit for approval',
  ABSOLUTE = 'absolute',
  DIV = 'div',
  _2D = '2d',
  DOWNLOAD='Download Map',
  APPROVAL_REPORT='Approval Report'
}
